import * as React from "react";
const SvgFiRrRegionPin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-region-pin_svg__a)">
      <path
        fill="#062147"
        d="M9.95 11.189a2.92 2.92 0 0 0 2.049.828c.74 0 1.483-.275 2.048-.828l1.84-1.801a5.46 5.46 0 0 0 1.611-3.889c0-1.47-.572-2.85-1.61-3.889a5.46 5.46 0 0 0-3.89-1.611c-1.47 0-2.85.572-3.888 1.611a5.46 5.46 0 0 0-1.611 3.889c0 1.469.572 2.851 1.619 3.896zm-.425-8.164A3.48 3.48 0 0 1 11.999 2c.934 0 1.813.364 2.474 1.025A3.48 3.48 0 0 1 15.499 5.5a3.47 3.47 0 0 1-1.018 2.467L12.648 9.76a.936.936 0 0 1-1.3 0L9.523 7.975A3.48 3.48 0 0 1 8.498 5.5c0-.935.364-1.813 1.025-2.475zm.974 2.469a1.5 1.5 0 1 1 3.002.001 1.5 1.5 0 0 1-3.001-.001m13.498 13.259-.979-8.318a4.69 4.69 0 0 0-2.573-3.658 1.002 1.002 0 0 0-.892 1.791 2.69 2.69 0 0 1 1.479 2.101l.078.671-10.528 5.014-7.29-6.535c.25-.517.646-.956 1.17-1.229a1 1 0 0 0 .424-1.349 1 1 0 0 0-1.35-.425 4.7 4.7 0 0 0-2.495 3.618l-.978 8.319A4.7 4.7 0 0 0 4.728 24H19.33a4.698 4.698 0 0 0 4.666-5.247M2.714 21.095a2.7 2.7 0 0 1-.663-2.107l.809-6.875 11.029 9.888h-9.16c-.77 0-1.504-.33-2.016-.905zm18.635 0A2.7 2.7 0 0 1 19.33 22h-2.45l-4.684-4.2 9.16-4.362.654 5.55a2.7 2.7 0 0 1-.663 2.107"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-region-pin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRegionPin;
